<div class="contiene">
    <div class="logo">
        <img *ngIf="imgenLogo" src="https://triidyftp.s3.us-east-2.amazonaws.com/Tiendas/{{imgenLogo}}.jpg" alt="Triidy">
        <img *ngIf="!imgenLogo" src="https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/Logo_Triidy_3.0.svg" alt="Triidy">
        <h3 *ngIf="cuadForm">¡Tu producto está listo para enviarse!</h3>
    </div>
    <div class="cuad1" *ngIf="cuadForm">
        <h4>Pide ahora y aprovecha la oferta</h4>
        <form [formGroup]="productoForm">
            <div class="row">
                <div class="col izq">
                    <mat-form-field appearance="outline">
                        <mat-label>Nombre completo</mat-label>
                        <input matInput placeholder="Nombre Completo" formControlName="nombreCtrl" #nombre>
                        <mat-error *ngIf="getControl('nombreCtrl').errors?.required">Falta campo Nombre
                        </mat-error>
                        <mat-hint style="color: blue" *ngIf="getControl('nombreCtrl').errors?.maxLength">Supera caracteres maximos (60)</mat-hint>
                    </mat-form-field>
                    <mat-form-field appearance="outline">
                        <mat-label>Numero Celular</mat-label>
                        <input matInput placeholder="Numero Celular" formControlName="telefonoCtrl" #telefono>
                        <mat-error *ngIf="getControl('telefonoCtrl').errors?.required">Falta campo Telefono
                        </mat-error>
                        <mat-hint style="color: blue" *ngIf="getControl('telefonoCtrl').errors?.pattern">No es un numero de telefono
                        </mat-hint>
                    </mat-form-field>
                    <mat-form-field appearance="outline">
                        <mat-label>Correo electrónico</mat-label>
                        <input matInput placeholder="Correo Electronico" formControlName="emailCtrl" #email>
                        <mat-error *ngIf="getControl('emailCtrl').errors?.required">Falta campo Correo Electronico
                        </mat-error>
                        <mat-hint style="color: blue" *ngIf="getControl('emailCtrl').errors?.email">No es un correo electronico
                        </mat-hint>
                    </mat-form-field>
                    <mat-form-field appearance="outline">
                        <mat-label>Ciudad</mat-label>
                        <!-- <mat-select formControlName="ciudadCtrl" required>
                            <mat-option *ngFor="let option of Ciudades" [value]="option.id_ciudad" (onSelectionChange)="onSelectedOption(option, $event)">
                                {{option.ciudad_full}}
                            </mat-option>
                        </mat-select> -->
                        <input type="text" matInput formControlName="ciudadCtrl" [matAutocomplete]="auto" required>
                        <mat-autocomplete #auto="matAutocomplete">
                            <mat-option *ngFor="let option of filteredOptions | async" [value]="option.ciudad_full" (onSelectionChange)="onSelectedOption(option, $event)">
                                {{option.ciudad_full}}
                            </mat-option>
                        </mat-autocomplete>
                        <mat-error *ngIf="getControl('ciudadCtrl').errors?.required">Debe elegir una ciudad de la lista
                        </mat-error>
                    </mat-form-field>
                    <mat-form-field appearance="outline">
                        <mat-label>Dirección</mat-label>
                        <input matInput placeholder="Dirección" formControlName="direccionCtrl" #direccion>
                        <mat-error *ngIf="getControl('direccionCtrl').errors?.required">Falta campo Direccion
                        </mat-error>
                        <!-- <mat-hint>Hint</mat-hint> -->
                    </mat-form-field>
                </div>
                <div class="col der">
                    <h5 style="display: none;">CANTIDAD</h5>
                    <mat-form-field style="display: none;" appearance="outline">
                        <mat-label>Cantidad</mat-label>
                        <input matInput type="number" min="1" max="100" placeholder="Cantidad" autocomplete="off" formControlName="cantidadCtrl" #cantidad>
                        <mat-error *ngIf="getControl('cantidadCtrl').errors?.required">Falta campo Cantidad
                        </mat-error>
                        <mat-hint style="color: blue" *ngIf="getControl('cantidadCtrl').errors?.min">La compra minima es de (1) un producto
                        </mat-hint>
                    </mat-form-field>
                    <h5>DETALLE DE PEDIDO</h5>
                    <p>{{ productos?.nombre_producto }}</p>
                    <h5>VALOR TOTAL</h5>
                    <p>{{ changeCoin() }} {{ changeValueCoin(valorT) }}</p>
                    <h5>MÉTODO DE PAGO</h5>
                    <mat-radio-group class="radio-group" formControlName="metodoCtrl" #metodoPago>
                        <mat-radio-button class="radButton" value="TriidyPay"><img class="img1" src="https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/IconElectronico.png" alt="Triidy">Pago electrónico</mat-radio-button>
                        <mat-radio-button *ngIf="ciudadSelected?.contraentrega !== 'NO'" class="radButton" value="Contraentrega"><img class="img2" src="https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/IconContraentrega.png" alt="Triidy">Contraentrega</mat-radio-button>
                    </mat-radio-group>
                    <mat-error *ngIf="getControl('metodoCtrl').errors?.required">Falta escoger un metodo de pago
                    </mat-error>
                </div>
            </div>
            <button type="submit" class="btn" [disabled]="!productoForm.valid" (click)="venta()">Realizar
                pedido</button>
        </form>
        <p class="foot">Pago procesado por <img src="https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/IconTriidyPay.png" alt="Triidy"></p>
    </div>
    <div class="cuad2" *ngIf="cuadPreV">
        <span class="back" (click)="volverForm()"><i class="fas fa-chevron-left"></i> Volver</span>
        <h4>Verificación de compra</h4>
        <div class="row">
            <div class="col izq">
                <h5>DETALLE DE PEDIDO</h5>
                <p>{{ productos?.nombre_producto }}</p>
                <h5>VALOR TOTAL</h5>
                <p>{{ changeCoin() }} {{ changeValueCoin(objetoProducto?.valor_recaudo) }}</p>
                <h5>MÉTODO DE PAGO</h5>
                <p *ngIf="objetoProducto?.forma_pago === 'TriidyPay'"><img class="img1" src="https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/IconElectronico.png" alt="Triidy"> Pago Electronico</p>
                <p *ngIf="objetoProducto?.forma_pago === 'Contraentrega'"><img class="img2" src="https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/IconContraentrega.png" alt="Triidy"> Contraentrega</p>
            </div>
            <div class="col der">
                <h5>CIUDAD</h5>
                <p>{{ ciudadSelected?.ciudad_full }}</p>
                <h5>DIRECCIÓN</h5>
                <p>{{ objetoProducto?.direccion }}</p>
                <h5>CORREO</h5>
                <p>{{ objetoProducto?.correo }}</p>
            </div>
        </div>
        <button type="submit" class="btn" (click)="venta()">Finalizar pedido</button>
        <p class="foot">Pago procesado por <img src="https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/IconTriidyPay.png" alt="Triidy"></p>
    </div>
    <div class="cuad3" *ngIf="cuadFin">
        <div class="final">
            <h2>¡Gracias por tu compra!</h2>
            <h3>NO. DE PEDIDO</h3>
            <h4>{{ idPedidoFinal }}</h4>
            <p class="max">Te notificaremos via mensaje de texto o correo electrónico el estado de entrega de tu pedido,
                <span>recuerda tener el dinero a
                    la mano</span> en el momento de la entrega.
            </p>
            <p class="min">A tu correo enviaremos toda la información de contacto de nuestra tienda. Contamos con el respaldo de TriidyPay, tu compra esta asegurada para proteger tus datos y minimizar riesgos de fraude
            </p>
        </div>
        <p class="foot">Pago procesado por <img src="https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/IconTriidyPay.png" alt="Triidy"></p>
    </div>
    <div class="cuadCharge" *ngIf="cuadChar">
        <div class="spinn">
            <mat-spinner></mat-spinner>
            <p>{{ mensajeSpinner }}</p>
        </div>
    </div>
    <div class="cuadError" *ngIf="cuandErr">
        <img src="https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/ErrorCheckout.png" alt="Triidy">
        <h5>¡Algo ha salido mal!</h5>
        <p>{{ msgError }}</p>
    </div>
</div>
